import { Link, matchPath, useLocation } from "react-router";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { useVoltAreas, useVoltNavGroups } from "./useVoltNavGroups";

const buttonClass = "flex-col gap-1 h-auto py-2 px-1 rounded-md w-16";

/** Volt entries of the phone bar: one button per Volt group of voltNavGroups. */
export const VoltMobileNavItems = () => {
  const areas = useVoltAreas();
  const groups = useVoltNavGroups(areas).filter((g) => g.key !== "crm");
  const { pathname } = useLocation();
  return (
    <>
      {groups.map((group) => {
        const entry = group.items.find((i) => i.to) ?? group.items[0];
        if (!entry) return null;
        const Icon = entry.icon;
        const active = group.items.some(
          (i) =>
            i.match && matchPath(`${i.match.replace(/\/\*$/, "")}/*`, pathname),
        );
        const body = (
          <>
            <Icon className="size-6" />
            <span className="text-[0.6rem] font-medium">{group.label}</span>
          </>
        );
        return (
          <Button
            key={group.key}
            asChild
            variant="ghost"
            className={cn(buttonClass, active ? null : "text-muted-foreground")}
          >
            {entry.to ? (
              <Link to={entry.to}>{body}</Link>
            ) : (
              <a href={entry.href}>{body}</a>
            )}
          </Button>
        );
      })}
    </>
  );
};
